export const RECONNECTION_TOOLTIP = "Their phone may be off or in airplane mode. It'll deliver when they reconnect.";

// Unknown receipt support stays Sent. Evidence is channel-specific: SMS delivery
// history never claims that the same carrier supports MMS delivery receipts.
export function supportsDeliveryReceipts(item, history = []) {
    if (item.deliveryReceipts === false) return false;
    if (item.channel === 'whatsapp') return true;
    if (item.channel !== 'sms') return false;
    if (item.deliveryReceipts === true) return true;
    if (!item.sendingLine) return false;
    return history.some((entry) => entry.direction === 'outbound' && entry.channel === item.channel
        && entry.sendingLine === item.sendingLine && (!item.carrier || entry.carrier === item.carrier)
        && ['delivered', 'read'].includes(entry.provider_status));
}
export function waitingForReconnection(item, { now = Date.now(), minutes = 15, history = [] } = {}) {
    const at = typeof item?.at === 'number' ? item.at : Date.parse(item?.at || '');
    return item?.direction === 'outbound' && item.provider_status === 'sent' && Number.isFinite(at)
        && now - at > Math.max(1, Number(minutes) || 15) * 60000 && supportsDeliveryReceipts(item, history);
}
export function whatsappChecks(status) {
    return status === 'read' ? { text: '✓✓', label: 'Read', read: true }
        : status === 'delivered' ? { text: '✓✓', label: 'Delivered' }
            : status === 'sent' ? { text: '✓', label: 'Sent' } : null;
}
